// extracted by mini-css-extract-plugin
export default {"tooltip":"Ko-z","sharingV2":"Lo-z","sharingIconsV2":"Mo-z","links":"No-z","link":"Oo-z","facebookV2":"Po-z","twitterV2":"Qo-z","pinterestV2":"Ro-z"};